import React from "react";

const DeltaPill = ({ pct, direction = "up", negative = false, tokens }) => {
  if (pct == null || Number.isNaN(pct)) return null;
  const isNeg = !!negative;
  const colorBase = isNeg ? tokens.breach : tokens.healthy;
  const bg = isNeg ? tokens.breachBg : tokens.healthyBg;
  const text = isNeg ? tokens.breachText : tokens.healthyText;
  const arrow = direction === "up" ? "▲" : "▼";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "1px 6px",
        borderRadius: 6,
        background: bg,
        fontSize: 11,
        fontWeight: 700,
        color: text,
        fontVariantNumeric: "tabular-nums",
        lineHeight: 1.4
      }}
    >
      <span style={{ color: colorBase, fontSize: 9 }}>{arrow}</span>
      {Math.abs(pct).toFixed(1)}%
    </span>
  );
};

export default DeltaPill;
